type heavyMachineSubGroup = {
  id: string;
  name: string;
  heavyMachineGroupId: string;
};
type Window = {
  heavyMachineSubGroups: heavyMachineSubGroup[];
};
declare const window: Window;

const createOption = (label, value) => {
  const option = document.createElement("option");
  option.text = label;
  option.value = value;
  return option;
};

const apply = () => {
  if (!window.heavyMachineSubGroups) return;

  const groupSelectbox =
    (document.getElementById("heavy_machine_heavy_machine_group_id") as HTMLInputElement) ||
    (document.getElementById("check_list_heavy_machine_group_id") as HTMLInputElement);
  if (!groupSelectbox) return;

  const subGroupSelectbox =
    (document.getElementById("heavy_machine_heavy_machine_sub_group_id") as HTMLInputElement) ||
    (document.getElementById("check_list_heavy_machine_sub_group_id") as HTMLInputElement);
  if (!subGroupSelectbox) return;

  const handler = () => {
    const selectableSubGroups = window.heavyMachineSubGroups.filter((sg) => sg.heavyMachineGroupId === groupSelectbox.value);

    // 選択していた値を記憶しておく
    const preValue = subGroupSelectbox.value;

    // 選択肢を削除
    while (subGroupSelectbox.firstChild) {
      subGroupSelectbox.removeChild(subGroupSelectbox.firstChild);
    }

    // 選択肢を設定
    subGroupSelectbox.appendChild(createOption("選択してください", ""));
    selectableSubGroups.forEach((sg) => {
      subGroupSelectbox.appendChild(createOption(sg.name, sg.id));
    });

    // もともと選択していたものが選択肢に含まれる場合は再セット
    if (selectableSubGroups.map((sg) => sg.id).includes(preValue)) {
      subGroupSelectbox.value = preValue;
    }
  };
  handler();
  groupSelectbox.addEventListener("change", handler);
};

const initialHeavyMachineGroupSelectbox = () => {
  ["turbo:load", "turbo:render"].forEach((event) => document.addEventListener(event, apply));
};

export default initialHeavyMachineGroupSelectbox;
